import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';

export default function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { count: notifCount } = useNotifications();

  const handleLogout = () => { logout(); navigate('/login'); };

  const initials = `${(user?.first_name || '')[0] || ''}${(user?.last_name || '')[0] || ''}`.toUpperCase() || 'U';

  const avatarUrl = user?.avatar ? (user.avatar.startsWith('http') ? user.avatar : `${process.env.REACT_APP_API_URL || 'https://admined.cgiibnn-esursi.cd/'}${user.avatar}`) : null;

  const adminLinks = [
    { to: '/admin/dashboard', icon: 'bi-grid-1x2-fill', label: 'Dashboard' },
    { to: '/admin/universites', icon: 'bi-building', label: 'Universités' },
    { to: '/admin/facultes', icon: 'bi-bank2', label: 'Facultés' },
    { to: '/admin/promotions', icon: 'bi-mortarboard-fill', label: 'Promotions' },
    { to: '/admin/users', icon: 'bi-people-fill', label: 'Utilisateurs' },
    { to: '/stats', icon: 'bi-bar-chart-line-fill', label: 'Statistiques' },
  ];

  const enseignantLinks = [
    { to: '/enseignant/dashboard', icon: 'bi-grid-1x2-fill', label: 'Dashboard' },
    { to: '/enseignant/cours', icon: 'bi-book-fill', label: 'Mes cours' },
    { to: '/enseignant/seances', icon: 'bi-calendar-event-fill', label: 'Séances' },
    { to: '/enseignant/evaluations', icon: 'bi-clipboard-check-fill', label: 'Évaluations' },
    { to: '/enseignant/qcm', icon: 'bi-ui-checks', label: 'QCM' },
    { to: '/enseignant/notes', icon: 'bi-journal-check', label: 'Notes' },
    { to: '/enseignant/copies', icon: 'bi-file-earmark-text', label: 'Copies' },
    { to: '/stats', icon: 'bi-bar-chart-line-fill', label: 'Statistiques' },
  ];

  const etudiantLinks = [
    { to: '/etudiant/dashboard', icon: 'bi-grid-1x2-fill', label: 'Dashboard' },
    { to: '/etudiant/cours', icon: 'bi-book-fill', label: 'Mes cours' },
    { to: '/etudiant/evaluations', icon: 'bi-clipboard-check-fill', label: 'Évaluations' },
    { to: '/etudiant/soumissions', icon: 'bi-upload', label: 'Soumissions' },
    { to: '/etudiant/notes', icon: 'bi-journal-check', label: 'Mes notes' },
    { to: '/stats', icon: 'bi-bar-chart-line-fill', label: 'Statistiques' },
  ];

  const links = user?.role === 'admin' ? adminLinks
    : user?.role === 'enseignant' ? enseignantLinks
    : etudiantLinks;

  const roleLabel = user?.role === 'admin' ? 'Administration'
    : user?.role === 'enseignant' ? 'Enseignement'
    : 'Espace étudiant';

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'visible' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <img src="/icon-.png" alt="Classroom BNN" className="brand-icon" />
          <div>
            <span className="brand-text">Classroom BNN</span>
            <span className="brand-sub">Enseignement en ligne</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <span className="sidebar-section-label">{roleLabel}</span>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <i className={`bi ${l.icon}`} />
              <span>{l.label}</span>
            </NavLink>
          ))}

          <span className="sidebar-section-label">Général</span>
          <NavLink
            to="/notifications"
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={onClose}
          >
            <i className="bi bi-bell-fill" />
            <span>Notifications</span>
            {notifCount > 0 && <span className="badge-notif">{notifCount}</span>}
          </NavLink>
          <NavLink
            to="/profile"
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={onClose}
          >
            <i className="bi bi-person-fill" />
            <span>Mon profil</span>
          </NavLink>
        </nav>

        <div className="sidebar-user">
          <div className="user-avatar">
            {avatarUrl ? <img src={avatarUrl} alt="avatar" /> : initials}
          </div>
          <div className="user-info">
            <div className="user-name">{user?.first_name} {user?.last_name}</div>
            <div className="user-role">{user?.role}</div>
          </div>
          <button className="btn-logout" onClick={handleLogout} title="Déconnexion">
            <i className="bi bi-box-arrow-right" />
          </button>
        </div>
      </aside>
    </>
  );
}
